import React, { useEffect, useState } from "react";
import RootModal from "../../../common/RootModal";
import ConfirmationModalNew from "../../../common/ConfirmationModalNew";
import Button from "../../../common/Button";
import { ChevronRightIcon } from "@heroicons/react/24/outline";

const PrescriptionMedicationsAlert = ({
  open,
  handleClose,
  confirmAction,
  q1,
  q2,
}) => {
  const [ans1Yes, setAns1Yes] = useState(q1);
  const [ans2Yes, setAns2Yes] = useState(q2);
  const [allowContinue, setAllowContinue] = useState(false);

  useEffect(() => {
    if (ans1Yes !== null && ans2Yes !== null) setAllowContinue(true);
    else setAllowContinue(false);
  }, [ans1Yes, ans2Yes]);

  useEffect(() => {
    setAns1Yes(q1);
    setAns2Yes(q2);
  }, [open]);

  return (
    <ConfirmationModalNew
      open={open}
      title={"Recent Medication Changes"}
      content={() => (
        <div className="flex flex-col gap-8 text-gray-600 text-base">
          <div className="flex flex-col gap-4">
            <p>
              Did you start any new <b>Prescription</b> medications within the
              last 3 months?
            </p>
          </div>
          <div className={`grid grid-cols-2 gap-5`}>
            <Button
              className={`${ans1Yes !== null && ans1Yes && "!bg-gray-50"}`}
              type={"primary-outline"}
              text={"Yes"}
              onClick={() => setAns1Yes(true)}
            />
            <Button
              className={`${ans1Yes !== null && !ans1Yes && "!bg-gray-50"}`}
              type={"primary-outline"}
              text={"No"}
              onClick={() => setAns1Yes(false)}
            />
          </div>
          <div className="border-b border-gray-300 pt-2"></div>
          <div className="flex flex-col gap-4">
            <p>
              Did you start any new <b>Non-Prescription</b> medications within
              the last 3 months?
            </p>
          </div>
          <div className={`grid grid-cols-2 gap-5`}>
            <Button
              className={`${ans2Yes !== null && ans2Yes && "!bg-gray-50"}`}
              type={"primary-outline"}
              text={"Yes"}
              onClick={() => setAns2Yes(true)}
            />
            <Button
              className={`${ans2Yes !== null && !ans2Yes && "!bg-gray-50"}`}
              type={"primary-outline"}
              text={"No"}
              onClick={() => setAns2Yes(false)}
            />
          </div>
          <div>
            <button
              className={`float-right h-[38px] w-auto rounded-full bg-REELTeal border-REELTeal hover:bg-teal-200 text-white inline-flex 
            border transition-all duration-300 items-center font-semibold justify-center px-3 py-4 ${
              !allowContinue && "opacity-40 pointer-events-none"
            }`}
              disabled={!allowContinue}
              onClick={() => confirmAction(ans1Yes, ans2Yes)}
            >
              <h3 className="text-body-md font-semibold text-white">
                Continue
              </h3>
              <ChevronRightIcon className="w-4 ml-2 h-4 text-white" />
            </button>
          </div>
        </div>
      )}
      hideActions={true}
      handleClose={() => handleClose(PrescriptionMedicationsAlert.displayName)}
      onCross={() => handleClose(PrescriptionMedicationsAlert.displayName)}
    />
  );
};

PrescriptionMedicationsAlert.displayName = "PrescriptionMedicationsAlert";

export default PrescriptionMedicationsAlert;
